import { Box, Chip, CircularProgress } from "@mui/material"
import { Else, If } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ALL_SCOPE, isAsyncScope, isSelectableScope } from "routes/regime/plugins/regime-search/lib/search-scopes.js"
import Iconify from "minimals-template/components/Iconify.js"
import { iconForScope } from "routes/regime/plugins/regime-search/lib/search-icons.js"

export function RegimeSearchScopeChip({ item }) {
    const { searchScope, setSearchScope, scopeCounts, resultsLoading } = useBoundContext()
    const count = scopeCounts[item.id] ?? 0
    const active = searchScope === item.id
    const color = active ? "primary" : "default"
    const variant = active ? "filled" : "outlined"
    const pending = resultsLoading && isAsyncScope(item.id)
    const disabled = !active && !isSelectableScope(item.id, scopeCounts, resultsLoading)

    return (
        <Chip
            data-cy={`regime-search-scope-${item.id}`}
            size="small"
            clickable
            disabled={disabled}
            tabIndex={-1}
            aria-pressed={active}
            icon={<Iconify icon={iconForScope(item.id)} sx={{ width: 16, height: 16 }} />}
            label={
                <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                    {item.label}
                    <If value={pending}>
                        <CircularProgress data-cy="regime-search-scope-spinner" size={10} color="inherit" />
                        <Else>
                            <Box component="span">{count}</Box>
                        </Else>
                    </If>
                </Box>
            }
            color={color}
            variant={variant}
            onClick={selectScope}
        />
    )

    function selectScope() {
        setSearchScope(active ? ALL_SCOPE : item.id)
    }
}
